/** @format */
import {PointName} from 'components/charts/multiline-chart/model/common';

import {GraphComplexValuesList, GraphStat} from '../../models/common';
import {ChartIds} from '../../models/chartIds';
import {ALL_CHART_IDS} from '../../constants/allChartIds';
import {WIDGETS_LIST} from '../../constants/widgets';

const makeZeroMetrics = (): Record<ChartIds, number> => {
  const obj = {} as Record<ChartIds, number>;
  ALL_CHART_IDS.forEach(key => {
    obj[key] = 0;
  });
  return obj;
};

interface Options {
  graphStats: GraphStat[];
  rechartsDates: string[];
  complexList: GraphComplexValuesList;
}

const aggregateGraphStats = ({graphStats, rechartsDates, complexList}: Options): GraphStat[] => {
  if (!rechartsDates.length || !graphStats.length) {
    return [];
  }

  const discreteSet = new Set(rechartsDates);
  const allPoints = Object.keys(complexList) as PointName[];

  let acc = makeZeroMetrics();
  const result: GraphStat[] = [];

  graphStats.forEach((stat, index) => {
    const isDiscrete = discreteSet.has(stat.date);

    if (isDiscrete) {
      ALL_CHART_IDS.forEach(key => {
        const predicate = WIDGETS_LIST[key].complexRatioPredicate;
        if (predicate) {
          // Если график составной, то для вычисления значения используем predicate и уже готовые данные из complexList
          const currentPoint = allPoints[index];
          acc[key] = predicate(complexList[currentPoint].values);
        } else {
          // Обычная агрегация для простого графика
          acc[key] += stat[key];
        }
      });

      result.push({
        date: stat.date,
        ...acc,
      });

      acc = makeZeroMetrics();
    } else {
      ALL_CHART_IDS.forEach(key => {
        // Если график составной, то ничего не делаем
        const isComplex = Boolean(WIDGETS_LIST[key].complexRatioPredicate);
        if (!isComplex) {
          // Обычная агрегация для простого графика
          acc[key] += stat[key];
        }
      });
    }
  });

  return result;
};

export {aggregateGraphStats};
